export function doesStatusMatch(statusCode: number, statusCodeArray: Array<number>) {
  return statusCodeArray.some(e => e === statusCode);
}